import RoutingActions from '../../../actions/RoutingActions';
// import PosCartActions from '../../actions/PosCartActions';
import PosActions from '../../../actions/PosActions';

import PosStore from '../../../stores/PosStore';

class AvailableDiscounts extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            availableDiscounts : PosStore.getState().availableDiscounts
        };

        this.componentWillMount = this.componentWillMount.bind(this);
        this.onPosStoreChange = this.onPosStoreChange.bind(this);
        this.selectDiscount = this.selectDiscount.bind(this);
    }

    componentWillMount() {
        PosActions.loadAvailableDiscounts(this.props.guest.Guest_id, this.props.item.ProductId)
        PosStore.addChangeListener(this.onPosStoreChange);
    }

    componentWillUnmount() {
        PosStore.removeChangeListener(this.onPosStoreChange);
    }

    onPosStoreChange() {
        this.setState({
            availableDiscounts : PosStore.getState().availableDiscounts
        });
    }

    selectDiscount(discount) {
        this.props.selectDiscount(discount);
    }

    render() {
        var self = this;

        var guest       = this.props.guest;
        var selectedDiscount    = this.props.selectedDiscount;
        var discounts   = this.state.availableDiscounts;
        var amount      = 0;
        var rowStyle    = '#ffffff';

        return (
            <div className='available-discounts'>

                <div className='available-discounts__header'>
                    AVAILABLE DISCOUNTS
                </div>

                <div className='available-discounts__description'>
                    <div className='available-discounts__row--name'>
                        Discount Name
                    </div>
                </div>

                { !discounts &&
                    <div className='available-discounts__container'>
                        <div className='available-discounts__loading'>
                            Loading Discounts
                        </div>
                    </div>
                }

                { discounts && discounts.length === 0 &&
                    <div className='available-discounts__container'>
                        <div className='available-discounts__loading'>
                            No Discounts
                        </div>
                    </div>
                }

                { discounts && discounts.length > 0 &&
                    <div className='available-discounts__container'>
                        { discounts.map((discount) => {

                            rowStyle = rowStyle === '#ffffff' ? '#ebebeb' : '#ffffff';
                            amount = discount.FlatFee !== 0 ? '$'+discount.FlatFee.toString() : (discount.PercentOff * 100).toString()+'%';

                            return (
                                <div
                                    style={{'backgroundColor' : (selectedDiscount && selectedDiscount.ProductId === discount.ProductId ? '#C0F0B9' : rowStyle) }}
                                    onClick={self.selectDiscount.bind(self, discount)}
                                    key={discount.ProductId}>

                                    <div className='available-discounts__row'>
                                        <div className='available-discounts__row--name'>
                                            {discount.ProductDesc}
                                        </div>
                                        <div className='available-discounts__row--amount'>
                                            {amount}
                                        </div>
                                        <div className='available-discounts__row--exp'>
                                            {moment(discount.ValidateDt).format('MMM D, YYYY')}
                                        </div>
                                    </div>

                                </div>
                            );
                        })}
                    </div>
                }
            </div>
        );
    }
}

export default AvailableDiscounts;



// WEBPACK FOOTER //
// ./ui_src/app/components/pos/discount/AvailableDiscounts.react.jsx